"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowActionsMenu = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var UIContent_1 = require("../../../../../UIContent");
var DisplayIcon_1 = require("../../../../../utils/comps/DisplayIcon");
var ActionMenu_1 = require("../../../../ActionMenu");
var handleRowActions_1 = require("../../../handlers/handleRowActions");
var styled_1 = require("../styled");
var StyledCustomSelectCompWrapper = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  /* width: 1.5rem; */\n  height: 2.5rem;\n"], ["\n  ", "\n  /* width: 1.5rem; */\n  height: 2.5rem;\n"])), styled_1.commonRowColActionMenuStyles);
// const CustomSelectComp =
var RowActionsMenu = function (_a) {
    var value = _a.value, rowIdx = _a.rowIdx, onChange = _a.onChange, id = _a.id, disableAddRow = _a.disableAddRow, setActionsActiveOnRow = _a.setActionsActiveOnRow, rowActionsButtonWidth = _a.rowActionsButtonWidth, _b = _a.conditionsToRender, conditionsToRender = _b === void 0 ? true : _b;
    var _c = (0, react_1.useState)(false), actionMenuIsOpen = _c[0], setActionMenuIsOpen = _c[1];
    var isFirstMount = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(function () {
        if (!isFirstMount.current) {
            setActionsActiveOnRow(actionMenuIsOpen ? rowIdx : undefined);
        }
        else {
            isFirstMount.current = false;
        }
    }, [actionMenuIsOpen]);
    // cuz if an actionmenu is open we want it to continue showing
    // on screen irrespective of other factors such as hover and such
    return (conditionsToRender || actionMenuIsOpen) && (react_1.default.createElement("div", { style: {
            zIndex: 2,
            position: "absolute",
            top: "50%",
            left: 0,
            transform: "translate(-50%, -50%)",
        } },
        react_1.default.createElement(ActionMenu_1.ActionMenu, { popOutOfOverflowHiddenParent: true, align: "left", setShowActions: function (showActions) {
                setActionMenuIsOpen(showActions);
            }, CustomSelectComp: function (_a) {
                var active = _a.active, onClick = _a.onClick;
                return (react_1.default.createElement(StyledCustomSelectCompWrapper, { style: { width: rowActionsButtonWidth + "px" }, onClick: onClick, active: active },
                    react_1.default.createElement(DisplayIcon_1.DisplayIcon, { icon: "DotsThreeVertical", size: 16 })));
            }, actions: __spreadArray(__spreadArray([], (!disableAddRow ? [
                {
                    display: UIContent_1.UIContent.SimpleTable.delete,
                    onClick: function () { return (0, handleRowActions_1.handleDeleteRow)({ value: value, rowIdx: rowIdx, onChange: onChange, id: id }); },
                },
                {
                    display: UIContent_1.UIContent.SimpleTable.duplicate,
                    onClick: function () { return (0, handleRowActions_1.handleDuplicateRow)({ value: value, rowIdx: rowIdx, onChange: onChange, id: id }); },
                },
                {
                    display: UIContent_1.UIContent.SimpleTable.insertRowBefore,
                    onClick: function () {
                        return (0, handleRowActions_1.handleInsertRowBefore)({ value: value, rowIdx: rowIdx, onChange: onChange, id: id });
                    },
                },
                {
                    display: UIContent_1.UIContent.SimpleTable.insertRowAfter,
                    onClick: function () {
                        return (0, handleRowActions_1.handleInsertRowAfter)({ value: value, rowIdx: rowIdx, onChange: onChange, id: id });
                    },
                },
            ] : []), true), [
                {
                    display: UIContent_1.UIContent.SimpleTable.clearContent,
                    onClick: function () {
                        return (0, handleRowActions_1.handleClearRowContent)({ value: value, rowIdx: rowIdx, onChange: onChange, id: id });
                    },
                },
            ], false) })));
};
exports.RowActionsMenu = RowActionsMenu;
var templateObject_1;
